import {
  IconTag,
  IconEdit,
  IconClick,
  IconSwords,
  IconChartBar,
  IconDeviceLaptop,
  IconDots,
} from '@tabler/icons-react'

import { SelectOption } from 'components/ui/select'

export const ONBOARDING_MOTIVATION_OPTIONS: SelectOption[] = [
  {
    id: 1,
    value: 'Keyword research for SEO purposes',
    name: 'onboarding_questionnaire_selection_kw_research',
    icon: IconTag,
  },
  {
    id: 2,
    value: 'Content ideation and creation',
    name: 'onboarding_questionnaire_selection_creation',
    icon: IconEdit,
  },
  {
    id: 3,
    value: 'Understand user behavior',
    name: 'onboarding_questionnaire_selection_user_behavior',
    icon: IconClick,
  },
  {
    id: 4,
    value: 'Competitor analysis',
    name: 'onboarding_questionnaire_selection_competitor_analysis',
    icon: IconSwords,
  },
  {
    id: 5,
    value: 'Market research',
    name: 'onboarding_questionnaire_selection_market_research',
    icon: IconChartBar,
  },
  {
    id: 6,
    value: 'Site audit',
    name: 'onboarding_questionnaire_selection_site_audit',
    icon: IconDeviceLaptop,
  },
  { id: 7, value: 'Other', name: 'other_industry', icon: IconDots },
]
